import { render, staticRenderFns } from "./batchSelect.vue?vue&type=template&id=38d3fcc8&scoped=true&"
import script from "./batchSelect.vue?vue&type=script&lang=js&"
export * from "./batchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3fcc8",
  null
  
)

export default component.exports